import { useState } from 'react';
import { Phone, Mail, MapPin, Send, CheckCircle } from 'lucide-react';
import './Contact.css';

const eventTypes = [
  'Anniversary', 'Bachelor/Bachelorette', 'Birthday', 'Corporate Event',
  'Reception / Wedding', 'Family Get Together', 'Café / Lounge / Bar',
  'Special Occasion', 'Other',
];

export default function Contact() {
  const [form, setForm] = useState({ name: '', email: '', phone: '', eventType: '', date: '', message: '' });
  const [sent, setSent] = useState(false);

  const handleChange = e => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = e => {
    e.preventDefault();
    // Simulate submission
    setTimeout(() => setSent(true), 600);
  };

  return (
    <div className="contact-page">
      <div className="page-hero">
        <span className="breadcrumb">Home / <span>Contact Us</span></span>
        <h1>Get In Touch</h1>
      </div>

      <section className="contact-section">
        <div className="container contact-inner">

          {/* Info Panel */}
          <div className="contact-info">
            <span className="section-tag">Contact Us</span>
            <h2 className="section-title">Let's Make Your Event Unforgettable</h2>
            <div className="red-line" />
            <p style={{ color: 'var(--gray)', lineHeight: 1.7, marginBottom: 32 }}>
              For more information on corporate event services, birthday parties, weddings or any private events, please fill out the form or call us directly.
            </p>

            <div className="info-cards">
              <div className="info-card">
                <div className="info-icon"><MapPin size={20} /></div>
                <div>
                  <h4>Address</h4>
                  <p>C-218 Hari Marg, Malviya Nagar<br />Jaipur, Rajasthan</p>
                </div>
              </div>
              <div className="info-card">
                <div className="info-icon"><Phone size={20} /></div>
                <div>
                  <h4>Phone</h4>
                  <a href="tel:+919414203966">+91 9414203966</a>
                  <a href="tel:+918209227045">+91 8209227045</a>
                </div>
              </div>
              <div className="info-card">
                <div className="info-icon"><Mail size={20} /></div>
                <div>
                  <h4>Email</h4>
                  <a href="mailto:info@jimmyzband.com">info@jimmyzband.com</a>
                </div>
              </div>
            </div>

            <div className="contact-map">
              <iframe
                title="Jimmy'z Band Location"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3560.5!2d75.7937!3d26.8505!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMjbCsDUxJzAxLjgiTiA3NcKwNDcnMzcuMyJF!5e0!3m2!1sen!2sin!4v1234567890"
                allowFullScreen
                loading="lazy"
              />
            </div>
          </div>

          {/* Form */}
          <div className="contact-form-wrap">
            <div className="form-header">
              <h3>Book Your Event</h3>
              <p>Fill out the form and we'll get back to you within 24 hours</p>
            </div>

            {sent ? (
              <div className="success-msg">
                <CheckCircle size={48} />
                <h3>Message Sent!</h3>
                <p>Thank you for reaching out. We'll contact you shortly to confirm your booking.</p>
              </div>
            ) : (
              <form className="contact-form" onSubmit={handleSubmit}>
                <div className="form-row">
                  <div className="form-group">
                    <label>Your Name *</label>
                    <input name="name" value={form.name} onChange={handleChange} placeholder="Full Name" required />
                  </div>
                  <div className="form-group">
                    <label>Phone Number *</label>
                    <input name="phone" value={form.phone} onChange={handleChange} placeholder="+91 XXXXXXXXXX" required />
                  </div>
                </div>
                <div className="form-group">
                  <label>Email Address</label>
                  <input type="email" name="email" value={form.email} onChange={handleChange} placeholder="your@email.com" />
                </div>
                <div className="form-row">
                  <div className="form-group">
                    <label>Event Type *</label>
                    <select name="eventType" value={form.eventType} onChange={handleChange} required>
                      <option value="">Select Event Type</option>
                      {eventTypes.map(e => <option key={e}>{e}</option>)}
                    </select>
                  </div>
                  <div className="form-group">
                    <label>Event Date</label>
                    <input type="date" name="date" value={form.date} onChange={handleChange} />
                  </div>
                </div>
                <div className="form-group">
                  <label>Your Message</label>
                  <textarea name="message" value={form.message} onChange={handleChange} rows={4} placeholder="Tell us about your event, venue, expected guests..." />
                </div>
                <button type="submit" className="btn-primary submit-btn">
                  <Send size={16} /> Send Message
                </button>
              </form>
            )}
          </div>
        </div>
      </section>
    </div>
  );
}
